import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDifferenceIgnored: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"difference-ignored"} maskId="square-filled-radius-0-stroke-1-IconDifferenceIgnored"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7.64648 15.6465L8.35352 16.3535L16.3535 8.35352L15.6465 7.64648L7.64648 15.6465Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDifferenceIgnored;
